import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { ChevronDown, Star, Shield, Trophy, Menu, X } from 'lucide-react';
import CaseOpening from '@/components/CaseOpening';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const faqData = [
  { q: "Deneme bonusu veren siteler güvenilir mi?", a: "Listelediğimiz siteler, lisans bilgileri ve kullanıcı yorumları dikkate alınarak seçilmektedir. SuperBet, VenomBet, MaxWin, RamadaBet, BetAsus, PashaGaming ve RoyalBet gibi siteler sektörde güvenilir olarak bilinen platformlardır." },
  { q: "SuperBet 500 TL deneme bonusu nasıl alınır?", a: "SuperBet'e yeni üye olarak kayıt olduktan sonra 500 TL deneme bonusu otomatik olarak hesabınıza tanımlanır. Maximum çekim limiti 2.500 TL'dir. Bonus almak için herhangi bir yatırım yapmanıza gerek yoktur." },
  { q: "VenomBet'in çekim limiti neden yok?", a: "VenomBet, 500 TL deneme bonusunda çekim limiti uygulamayan nadir sitelerden biridir. Bu sayede kazandığınız tutarın tamamını çekebilirsiniz. Bu avantaj VenomBet'i diğer sitelerden öne çıkaran en önemli özelliklerden biridir." },
  { q: "MaxWin ve RoyalBet arasındaki fark nedir?", a: "Her iki site de 500 TL deneme bonusu ve 3.000 TL maximum çekim limiti sunmaktadır. MaxWin casino ve spor bahisleri konusunda geniş bir yelpaze sunarken, RoyalBet özellikle canlı bahis seçenekleriyle öne çıkmaktadır." },
  { q: "RamadaBet 500 TL bonus çevrim şartı var mı?", a: "RamadaBet'in 500 TL deneme bonusunda belirli çevrim şartları bulunmaktadır. Maximum çekim limiti 1.500 TL'dir. Detaylı çevrim şartları için siteye kayıt olduktan sonra bonus kurallarını incelemenizi öneririz." },
  { q: "BetAsus ve PashaGaming bonusları karşılaştırması nasıl?", a: "BetAsus 500 TL deneme bonusu ile 2.000 TL maximum çekim limiti sunarken, PashaGaming aynı bonus tutarında 1.000 TL çekim limiti uygulamaktadır. Çekim limiti açısından BetAsus daha avantajlıdır." },
  { q: "Çevrimsiz bonus nedir?", a: "Çevrimsiz bonus, herhangi bir çevrim şartı olmadan doğrudan çekilebilen bonus türüdür. Kazandığınızı anında hesabınıza aktarabilirsiniz." },
  { q: "Bonus almak için yatırım gerekir mi?", a: "Deneme bonusları genellikle yatırım gerektirmez. Listelediğimiz 7 sitenin hepsi yatırımsız 500 TL deneme bonusu vermektedir. Kayıt olduktan sonra bonus otomatik olarak hesabınıza tanımlanır." },
  { q: "Hangi site en yüksek çekim limitine sahip?", a: "VenomBet çekim limiti olmayan tek sitedir. Onun ardından MaxWin ve RoyalBet 3.000 TL, SuperBet 2.500 TL, BetAsus 2.000 TL, RamadaBet 1.500 TL ve PashaGaming 1.000 TL çekim limiti sunmaktadır." },
  { q: "En iyi bonus nasıl seçilir?", a: "En iyi bonusu seçerken çekim limiti, çevrim şartları, geçerlilik süresi ve sitenin güvenilirliğini değerlendirmenizi öneririz. Çekim limiti olmayan VenomBet veya yüksek limitli MaxWin ve RoyalBet iyi tercihlerdir." }
];

const seoContent = [
  { title: "Deneme Bonusu Nedir?", text: "Deneme bonusu, bahis ve casino sitelerinin yeni üyelere sunduğu ücretsiz bonus türüdür. Bu bonus sayesinde herhangi bir yatırım yapmadan siteyi test edebilir ve gerçek para kazanma şansını yakalayabilirsiniz. Deneme bonusları genellikle kayıt işleminin hemen ardından hesabınıza tanımlanır." },
  { title: "Çevrimsiz Bonus Ne Demek?", text: "Çevrimsiz bonus, klasik bonuslardan farklı olarak herhangi bir çevrim şartı içermeyen bonus türüdür. Normal bonuslarda kazancınızı çekebilmeniz için belirli bir tutarı çevirmeniz gerekirken, çevrimsiz bonuslarda böyle bir koşul yoktur. Kazancınız doğrudan çekilebilir durumdadır." },
  { title: "Kayıp Bonusu Nedir?", text: "Kayıp bonusu, belirli bir dönemde kaybettiğiniz tutarın bir kısmının size geri ödenmesidir. Bu bonus türü, oyuncuların kayıplarını telafi etmelerine yardımcı olur ve genellikle haftalık veya aylık olarak hesaplanır." },
  { title: "Bonus Veren Siteler Nasıl Seçilir?", text: "Güvenilir bir bonus sitesi seçerken lisans bilgilerini, ödeme yöntemlerini, müşteri hizmetleri kalitesini ve kullanıcı yorumlarını incelemeniz önemlidir. Ayrıca bonus şartlarını ve çevrim koşullarını dikkatle okumanızı tavsiye ederiz." },
  { title: "Güncel Giriş ve Bonus Takibi", text: "Bahis siteleri zaman zaman adres değişikliği yapabilir. Bonusal.vip olarak tüm güncel giriş adreslerini ve bonus kampanyalarını düzenli olarak takip ediyor ve sizinle paylaşıyoruz. Sayfamızı yer imlerinize ekleyerek her zaman en güncel bilgilere ulaşabilirsiniz." }
];

function BonusCard({ site, index }) {
  const handleClick = () => {
    axios.post(`${API}/public/track-click`, {
      site_id: site.id,
      site_name: site.name
    }).catch(() => {});
  };

  return (
    <div
      className="bonus-card p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 animate-fade-in-up"
      style={{ animationDelay: `${index * 80}ms` }}
      data-testid={`bonus-card-${index}`}
    >
      {/* Logo */}
      <div className="shrink-0 md:shrink-0 flex justify-center md:justify-start">
        <div className="w-[224px] h-[98px] md:w-48 md:h-20 rounded-xl bg-zinc-900 border border-yellow-400/20 flex items-center justify-center overflow-hidden p-3 md:p-2">
          {site.logo_url ? (
            <img
              src={site.logo_url}
              alt={site.name}
              className={`w-full h-full object-contain ${site.name === 'VenomBet' ? 'scale-[3.24]' : ''}`}
              loading="lazy"
            />
          ) : (
            <span className="text-yellow-400 font-bold text-xl" style={{ fontFamily: 'Outfit' }}>{site.name?.charAt(0)}</span>
          )}
        </div>
      </div>

      {/* Content - Centered */}
      <div className="flex-1 text-center min-w-0">
        <h3 className="text-white font-bold text-xl md:text-lg" style={{ fontFamily: 'Outfit' }}>{site.name}</h3>
        <p className="text-yellow-400 font-bold text-lg md:text-base mt-0.5">{site.bonus_title}</p>
        {site.bonus_description && <p className="text-zinc-400 font-semibold text-base md:text-sm mt-1">{site.bonus_description}</p>}
      </div>

      {/* CTA */}
      <a
        href={site.affiliate_link}
        target="_blank"
        rel="nofollow sponsored noopener noreferrer"
        className="btn-glow text-center text-sm md:text-base shrink-0 block md:inline-block"
        onClick={handleClick}
        data-testid={`bonus-register-btn-${index}`}
      >
        {site.button_text || 'Kayıt OL!'}
      </a>
    </div>
  );
}

export default function LandingPage() {
  const [sites, setSites] = useState([]);
  const [seo, setSeo] = useState({});
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/sites`).then(r => {
      const shuffled = [...r.data].sort(() => Math.random() - 0.5);
      setSites(shuffled);
    }).catch(() => {});
    axios.get(`${API}/public/seo`).then(r => setSeo(r.data)).catch(() => {});
  }, []);

  const scrollTo = (id) => {
    setMobileMenu(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  // JSON-LD Schemas
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Bonusal.vip",
    "url": "https://bonusal.vip",
    "description": seo.meta_description || "En populer bahis ve casino bonuslarini tek sayfada karsilastirin."
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://bonusal.vip/" }
    ]
  };

  return (
    <>
      {/* SEO Head */}
      {seo.meta_title && <title>{seo.meta_title}</title>}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

      <div className="min-h-screen" style={{ background: '#050505' }}>
        {/* ===== HEADER ===== */}
        <header className="sticky top-0 z-50 glass" data-testid="site-header">
          <div className="max-w-6xl mx-auto flex items-center justify-center md:justify-between px-4 py-3 md:px-6 md:py-4">
            <a href="/" className="flex items-center gap-2" data-testid="site-logo">
              <Trophy size={24} className="text-yellow-400 md:w-6 md:h-6 w-7 h-7" />
              <span className="text-2xl md:text-xl font-bold text-white" style={{ fontFamily: 'Outfit' }}>
                <span className="text-yellow-400">Bonusal</span>.vip
              </span>
            </a>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8">
              <button onClick={() => scrollTo('bonuslar')} className="text-yellow-400 hover:text-yellow-300 transition-colors text-sm font-bold" data-testid="nav-bonuslar">Güncel Bonuslar</button>
              <button onClick={() => scrollTo('deneme-bonusu')} className="text-yellow-400 hover:text-yellow-300 transition-colors text-sm font-bold" data-testid="nav-deneme">Deneme Bonusu</button>
              <button onClick={() => scrollTo('sss')} className="text-yellow-400 hover:text-yellow-300 transition-colors text-sm font-bold" data-testid="nav-sss">Sık Sorulanlar</button>
            </nav>
          </div>
        </header>

        {/* ===== CASE OPENING ===== */}
        <CaseOpening />

        {/* ===== CTA TEXT ===== */}
        <div className="text-center py-6 md:py-8">
          <p className="text-sm md:text-base text-yellow-400 font-semibold" style={{ fontFamily: 'Outfit' }}>Bonusunuzu Aktif Etmek İçin Üye OL Yatırımını Yap Bonusu Kap!</p>
        </div>

        {/* ===== BONUS LIST ===== */}
        <section id="bonuslar" className="relative px-4 pt-8 pb-16 md:pt-12 md:pb-24" data-testid="bonus-list-section">
          <img src="https://customer-assets.emergentagent.com/job_bonus-rehberi/artifacts/gy3v9l4e_Background%20Bonusal.png" alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0 bg-black/40" />
          <div className="relative z-10 max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight" style={{ fontFamily: 'Outfit', background: 'linear-gradient(135deg, #FACC15, #F59E0B, #D97706, #FACC15)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }} data-testid="page-title">
              Ödeme Garantili Bonus Veren Siteler
            </h1>
          </div>
          <div className="space-y-4" data-testid="bonus-list">
            {sites.map((site, idx) => (
              <BonusCard key={site.id} site={site} index={idx} />
            ))}
            {sites.length === 0 && (
              <div className="text-center py-20 text-zinc-600">Bonus siteleri yükleniyor...</div>
            )}
          </div>
          </div>
        </section>

        {/* ===== SEO CONTENT ===== */}
        <section id="deneme-bonusu" className="relative overflow-hidden border-y border-white/5" style={{ background: '#0A0A0A' }} data-testid="seo-content-section">
          <div className="max-w-4xl mx-auto px-4 py-16 md:py-24">
            <div className="space-y-12 md:space-y-16">
              {seoContent.map((item, idx) => (
                <article key={idx} className="animate-fade-in-up" style={{ animationDelay: `${idx * 100}ms` }}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-1 h-6 rounded-full bg-yellow-400" />
                    <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight" style={{ fontFamily: 'Outfit' }}>{item.title}</h2>
                  </div>
                  <p className="text-zinc-400 leading-relaxed text-base pl-6">{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ===== FAQ ===== */}
        <section id="sss" className="max-w-3xl mx-auto px-4 py-16 md:py-24" data-testid="faq-section">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-yellow-400 mb-3">Yardım Merkezi</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white" style={{ fontFamily: 'Outfit' }}>
              Sık Sorulan Sorular
            </h2>
          </div>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqData.map((faq, idx) => (
              <AccordionItem key={idx} value={`faq-${idx}`} className="bg-zinc-950 border border-white/10 rounded-xl overflow-hidden data-[state=open]:border-yellow-400/30 transition-colors">
                <AccordionTrigger className="px-5 md:px-6 py-4 text-left font-medium text-white hover:text-yellow-400 transition-colors text-sm md:text-base hover:no-underline" data-testid={`faq-trigger-${idx}`}>
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="px-5 md:px-6 pb-4 text-zinc-400 text-sm leading-relaxed" data-testid={`faq-content-${idx}`}>
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>

        {/* ===== FOOTER ===== */}
        <footer className="border-t border-white/5 py-12 md:py-16 px-4" style={{ background: '#000' }} data-testid="site-footer">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Trophy size={20} className="text-yellow-400" />
              <span className="text-lg font-bold text-white" style={{ fontFamily: 'Outfit' }}>
                <span className="text-yellow-400">Bonusal</span>.vip
              </span>
            </div>

            {/* 18+ Warning */}
            <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/20 rounded-full px-4 py-2" data-testid="age-warning">
              <Shield size={16} className="text-red-400" />
              <span className="text-red-400 text-sm font-medium">18+ | Kumar bağımlılık yapabilir</span>
            </div>

            <p className="text-zinc-600 text-sm leading-relaxed max-w-xl mx-auto">
              Bu site yalnızca bilgilendirme amaçlıdır. İçeriklerimiz affiliate (ortaklık) bağlantıları içerebilir. Kumar bağımlılık yapabilir, lütfen sorumlu oynayınız.
            </p>

            <div className="flex items-center justify-center gap-6 text-xs text-zinc-700">
              <a href="#" className="hover:text-zinc-400 transition-colors" data-testid="footer-privacy">Gizlilik Politikası</a>
              <span className="text-zinc-800">|</span>
              <a href="#" className="hover:text-zinc-400 transition-colors" data-testid="footer-terms">Kullanım Şartları</a>
              <span className="text-zinc-800">|</span>
              <a href="#" className="hover:text-zinc-400 transition-colors" data-testid="footer-responsible">Sorumlu Oyun</a>
            </div>

            <p className="text-zinc-800 text-xs">
              &copy; 2026 Bonusal.vip - Tüm hakları saklıdır.
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}
